<p-card class="flex justify-content-center">
  <form [formGroup]="newAccountForm" (ngSubmit)="submitForm()" novalidate>
    <p-fluid [class.pointer-events-none]="submitting" [class.opacity-60]="submitting">
      <div class="field flex flex-col gap-2">
        <label for="parentClientNumber" class="block" i18n="create account form|Form label">Parent Account</label>
        <app-account-selector
          formControlName="parentClientNumber"
          [additionalAccount]="currentAccount"></app-account-selector>
      </div>

      <div class="field flex flex-col gap-2">
        <div class="flex gap-2 items-baseline">
          <label for="email" class="block" i18n="create account form|Form label">Email</label>
          <app-required-marker />
        </div>
        <input type="text" pInputText formControlName="email" />
        @if (newAccountForm.get('email')?.invalid && newAccountForm.get('email')?.touched) {
          <p-message severity="error" size="small" variant="simple">
            @if (newAccountForm.get('email')?.hasError('required')) {
              <ng-container i18n="create account form|Email required error">Email is required.</ng-container>
            }
            @if(newAccountForm.get('email')?.hasError('email')) {
              <ng-container i18n="create account form|Email invalid error">Email must be a valid email address.</ng-container>
            }
            @for (remoteMessage of getRemoteValidationMessages(newAccountForm.get('email')); track remoteMessage) {
              <ng-container>
                {{ remoteMessage }}
              </ng-container>
            }
          </p-message>
        }
      </div>

      <div class="field flex flex-col gap-2">
        <div class="flex gap-2 items-baseline">
          <label for="login" class="block" i18n="create account form|Form label">Login Name</label>
          <app-required-marker />
        </div>
        <input type="text" pInputText formControlName="login" />
        @if (newAccountForm.get('login')?.invalid && newAccountForm.get('login')?.touched) {
          <p-message severity="error" size="small" variant="simple">
            @if (newAccountForm.get('login')?.hasError('required')) {
              <ng-container i18n="create account form|Login Name required error">Login Name is required.</ng-container>
            }
            @if(newAccountForm.get('login')?.hasError('pattern')) {
              <ng-container i18n="create account form|Login Name pattern error">Login Name must be lowercase alphanumeric and can include dots, underscores, and hyphens.</ng-container>
            }
            @if(newAccountForm.get('login')?.hasError('minlength')) {
              <ng-container i18n="create account form|Login Name minlength error">Login Name must be at least 8 characters long.</ng-container>
            }
            @if(newAccountForm.get('login')?.hasError('maxlength')) {
              <ng-container i18n="create account form|Login Name maxlength error">Login Name must be at most 255 characters long.</ng-container>
            }
            @for (remoteMessage of getRemoteValidationMessages(newAccountForm.get('login')); track remoteMessage) {
              <ng-container>
                {{ remoteMessage }}
              </ng-container>
            }
          </p-message>
        }
      </div>

      <div class="field flex flex-col gap-2">
        <div class="flex gap-2 items-baseline">
          <label for="company" class="block" i18n="create account form|Form label">Company</label>
          <app-required-marker />
        </div>
        <input type="text" pInputText formControlName="company" />
        @if (newAccountForm.get('company')?.invalid && newAccountForm.get('company')?.touched) {
          <p-message severity="error" size="small" variant="simple">
            @if (newAccountForm.get('company')?.hasError('required')) {
              <ng-container i18n="create account form|Company required error">Company is required.</ng-container>
            }
            @if(newAccountForm.get('company')?.hasError('pattern')) {
              <ng-container i18n="create account form|Company pattern error">Company must not start with a digit.</ng-container>
            }
            @for (remoteMessage of getRemoteValidationMessages(newAccountForm.get('company')); track remoteMessage) {
              <ng-container>
                {{ remoteMessage }}
              </ng-container>
            }
          </p-message>
        }
      </div>

      <div class="field flex flex-col gap-2">
        <div class="flex gap-2 items-baseline">
          <label for="firstname" class="block" i18n="create account form|Form label">First Name</label>
          <app-required-marker />
        </div>
        <input type="text" pInputText formControlName="firstname" />
        @if (newAccountForm.get('firstname')?.invalid && newAccountForm.get('firstname')?.touched) {
          <p-message severity="error" size="small" variant="simple">
            @if (newAccountForm.get('firstname')?.hasError('required')) {
              <ng-container i18n="create account form|First name required error">First name is required.</ng-container>
            }
            @if (newAccountForm.get('firstname')?.hasError('pattern')) {
              <ng-container i18n="create account form|First name pattern error">First name must not start with a digit.</ng-container>
            }
            @if(newAccountForm.get('firstname')?.hasError('minlength')) {
              <ng-container i18n="create account form|First name minlength error">First name must be at least 2 characters long.</ng-container>
            }
            @for (remoteMessage of getRemoteValidationMessages(newAccountForm.get('firstname')); track remoteMessage) {
              <ng-container>
                {{ remoteMessage }}
              </ng-container>
            }
          </p-message>
        }
      </div>

      <div class="field flex flex-col gap-2">
        <div class="flex gap-2 items-baseline">
          <label for="lastname" class="block" i18n="create account form|Form label">Last Name</label>
          <app-required-marker />
        </div>
        <input type="text" pInputText formControlName="lastname" />
        @if (newAccountForm.get('lastname')?.invalid && newAccountForm.get('lastname')?.touched) {
          <p-message severity="error" size="small" variant="simple">
            @if (newAccountForm.get('lastname')?.hasError('required')) {
              <ng-container i18n="create account form|Last name required error">Last name is required.</ng-container>
            }
            @if (newAccountForm.get('lastname')?.hasError('pattern')) {
              <ng-container i18n="create account form|Last name pattern error">Last name must not start with a digit.</ng-container>
            }
            @if(newAccountForm.get('lastname')?.hasError('minlength')) {
              <ng-container i18n="create account form|Last name minlength error">Last name must be at least 2 characters long.</ng-container>
            }
            @for (remoteMessage of getRemoteValidationMessages(newAccountForm.get('lastname')); track remoteMessage) {
              <ng-container>
                {{ remoteMessage }}
              </ng-container>
            }
          </p-message>
        }
      </div>

      <div class="field flex flex-col gap-2">
        <div class="flex gap-2 items-baseline">
          <label for="street" class="block" i18n="create account form|Form label">Street</label>
          <app-required-marker />
        </div>
        <input type="text" pInputText formControlName="street" />
        @if (newAccountForm.get('street')?.invalid && newAccountForm.get('street')?.touched) {
          <p-message severity="error" size="small" variant="simple">
            @if (newAccountForm.get('street')?.hasError('required')) {
              <ng-container i18n="create account form|Street is required error">Street is required.</ng-container>
            }
            @if(newAccountForm.get('street')?.hasError('pattern')) {
              <ng-container i18n="create account form|Street pattern error">Street must not start with a digit.</ng-container>
            }
            @for (remoteMessage of getRemoteValidationMessages(newAccountForm.get('street')); track remoteMessage) {
              <ng-container>
                {{ remoteMessage }}
              </ng-container>
            }
          </p-message>
        }
      </div>

      <div class="field flex flex-col gap-2">
        <div class="flex gap-2 items-baseline">
          <label for="city" class="block" i18n="create account form|Form label">City</label>
          <app-required-marker />
        </div>
        <input type="text" pInputText formControlName="city" />
        @if (newAccountForm.get('city')?.invalid && newAccountForm.get('city')?.touched) {
          <p-message severity="error" size="small" variant="simple">
            @if (newAccountForm.get('city')?.hasError('required')) {
              <ng-container i18n="create account form|City is required error">City is required.</ng-container>
            }
            @for (remoteMessage of getRemoteValidationMessages(newAccountForm.get('city')); track remoteMessage) {
              <ng-container>
                {{ remoteMessage }}
              </ng-container>
            }
          </p-message>
        }
      </div>

      <div class="field flex flex-col gap-2">
        <div class="flex gap-2 items-baseline">
          <label for="zip" class="block" i18n="create account form|Form label">Zip</label>
          <app-required-marker />
        </div>
        <input type="text" pInputText formControlName="zip" />
        @if (newAccountForm.get('zip')?.invalid && newAccountForm.get('zip')?.touched) {
          <p-message severity="error" size="small" variant="simple">
            @if (newAccountForm.get('zip')?.hasError('required')) {
              <ng-container i18n="create account form|Zip is required error">Zip is required.</ng-container>
            }
            @if (newAccountForm.get('zip')?.hasError('minlength')) {
              <ng-container i18n="create account form|Zip minlength error">Zip must be at least 3 characters long.</ng-container>
            }
            @if (newAccountForm.get('zip')?.hasError('maxlength')) {
              <ng-container i18n="create account form|Zip maxlength error">Zip must be at most 10 characters long.</ng-container>
            }
            @for (remoteMessage of getRemoteValidationMessages(newAccountForm.get('zip')); track remoteMessage) {
              <ng-container>
                {{ remoteMessage }}
              </ng-container>
            }
          </p-message>
        }
      </div>

      <div class="field flex flex-col gap-2">
        <div class="flex gap-2 items-baseline">
          <label for="country" class="block" i18n="create account form|Form label">Country</label>
          <app-required-marker />
        </div>
        <app-country-selector formControlName="country"></app-country-selector>
        @if (newAccountForm.get('country')?.invalid && newAccountForm.get('country')?.touched) {
          <p-message severity="error" size="small" variant="simple">
            @if (newAccountForm.get('country')?.hasError('required')) {
              <ng-container i18n="create account form|Country is required error">Country is required.</ng-container>
            }
            @for (remoteMessage of getRemoteValidationMessages(newAccountForm.get('country')); track remoteMessage) {
              <ng-container>
                {{ remoteMessage }}
              </ng-container>
            }
          </p-message>
        }
      </div>

      <div class="field flex flex-col gap-2">
        <label for="countryState" class="block" i18n="create account form|Form label">Country State/Province</label>
        <app-country-state-selector formControlName="countryStateComposite" [country]="newAccountForm.get('country')?.value"></app-country-state-selector>
      </div>

      <div class="field flex flex-col gap-2">
        <div class="flex gap-2 items-baseline">
          <label for="phone" class="block" i18n="create account form|Form label">Phone</label>
          <app-required-marker />
        </div>
        <input type="text" pInputText formControlName="phone" />
        @if (newAccountForm.get('phone')?.invalid && newAccountForm.get('phone')?.touched) {
          <p-message severity="error" size="small" variant="simple">
            @if (newAccountForm.get('phone')?.hasError('required')) {
              <ng-container i18n="create account form|Phone is required error">Phone is required.</ng-container>
            }
            @if (newAccountForm.get('phone')?.hasError('pattern')) {
              <ng-container i18n="create account form|Phone format error">Telephone Number must be in the format +[country code].[number], e.g. +1.123456789</ng-container>
            }
            @for (remoteMessage of getRemoteValidationMessages(newAccountForm.get('phone')); track remoteMessage) {
              <ng-container>
                {{ remoteMessage }}
              </ng-container>
            }
          </p-message>
        }
      </div>

      <div class="field flex flex-col gap-2">
        <label for="cellPhone" class="block" i18n="create account form|Form label">Cell Phone</label>
        <input type="text" pInputText formControlName="cellPhone" />
        @if (newAccountForm.get('cellPhone')?.invalid && newAccountForm.get('cellPhone')?.touched) {
          <p-message severity="error" size="small" variant="simple">
            @if (newAccountForm.get('cellPhone')?.hasError('pattern')) {
              <ng-container i18n="create account form|Cell Phone pattern error">Cell Phone must be a valid phone number.</ng-container>
            }
            @for (remoteMessage of getRemoteValidationMessages(newAccountForm.get('cellPhone')); track remoteMessage) {
              <ng-container>
                {{ remoteMessage }}
              </ng-container>
            }
          </p-message>
        }
      </div>

      <div class="field flex flex-col gap-2">
        <label for="fax" class="block" i18n="create account form|Form label">Fax</label>
        <input type="text" pInputText formControlName="fax" />
        @if (newAccountForm.get('fax')?.invalid && newAccountForm.get('fax')?.touched) {
          <p-message severity="error" size="small" variant="simple">
            @if (newAccountForm.get('fax')?.hasError('required')) {
              <ng-container i18n="create account form|Fax is required error">Fax is required.</ng-container>
            }
            @for (remoteMessage of getRemoteValidationMessages(newAccountForm.get('fax')); track remoteMessage) {
              <ng-container>
                {{ remoteMessage }}
              </ng-container>
            }
          </p-message>
        }
      </div>

      <div class="field flex flex-col gap-2">
        <label for="managerUserIds" class="block" i18n="create account form|Form label">Allow the following users to manage this account:</label>
        <app-account-user-selector
          formControlName="managerUserIds"
          [clientNumber]="userSourceClientNumber"></app-account-user-selector>
        @if (newAccountForm.get('managerUserIds')?.invalid && newAccountForm.get('managerUserIds')?.touched) {
          <p-message severity="error" size="small" variant="simple">
            @for (remoteMessage of getRemoteValidationMessages(newAccountForm.get('managerUserIds')); track remoteMessage) {
              <ng-container>
                {{ remoteMessage }}
              </ng-container>
            }
          </p-message>
        }
        <p-message severity="secondary" size="small" variant="simple" i18n="create account form|Manager hint">
          You will always be able to manage accounts you create.
        </p-message>
      </div>
    </p-fluid>

    <button
      pButton
      type="submit"
      label="Create Account"
      i18n-label="create account form|Create account button"
      [loading]="submitting"
      [disabled]="newAccountForm.invalid || submitting"></button>
  </form>
</p-card>